import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSession } from './session';

/** Keyboard shortcuts. Disabled via user preference `shortcuts=false`; while the entity is in setup only Escape works. */
export function useGlobalShortcuts(handlers: { openSearch: () => void; openPalette: () => void }) {
  const nav = useNavigate();
  const { me, canCreateCase } = useSession();
  useEffect(() => {
    if ((me?.preferences as { shortcuts?: boolean } | undefined)?.shortcuts === false) return;
    const setup = me?.operation === 'SETUP';
    let pendingG = false;
    let timer: number | undefined;
    const onKey = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement | null;
      const typing = !!target && (['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName) || target.isContentEditable);
      if (setup) { if (e.key === 'Escape') document.dispatchEvent(new CustomEvent('pqrs:close-drawers')); return; }
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); handlers.openPalette(); return; }
      if (typing) return;
      if (e.key === '/') { e.preventDefault(); handlers.openSearch(); return; }
      if (e.key === 'Escape') { document.dispatchEvent(new CustomEvent('pqrs:close-drawers')); return; }
      if (e.key.toLowerCase() === 'g') { pendingG = true; window.clearTimeout(timer); timer = window.setTimeout(() => (pendingG = false), 800); return; }
      if (pendingG) {
        pendingG = false;
        const map: Record<string, string> = { i: '/pqrs', m: '/tareas', d: '/', a: '/asignacion', r: '/reportes' };
        const to = map[e.key.toLowerCase()];
        if (to) { e.preventDefault(); nav(to); }
        return;
      }
      if (e.key.toLowerCase() === 'n' && canCreateCase) { e.preventDefault(); nav('/pqrs/nueva'); }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [nav, me, canCreateCase, handlers]);
}
